export default "__VITE_ASSET__Bf81keVO__"